module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/main/main.component.html
// module id = ./src/app/shared/components/main/main.component.html
// module chunks = main